'use strict';

import { view } from '@/functions';

const prefix = '/subscriptions';

export default [
    {
        path: prefix,
        name: 'subscriptions',
        meta: {
            title: 'Subscriptions',
            scopes: ['read_subscriptions', 'write_subscriptions']
        },
        component: () => view('subscriptions/index')
    },
    {
        path: `${prefix}/info`,
        name: 'subscriptions-info',
        meta: {
            title: 'Subscriptions',
            scopes: ['read_subscriptions', 'write_subscriptions']
        },
        component: () => view('subscriptions/info')
    },
];
